<div class="breadcrumb_outer">
    <ul class="breadcrumb">
      <li>
        <a>{{ company_name }}:</a>
      </li>
      <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
        <a (click)="goToPageLink(item.page_ref)">
          {{ item.page_title }}
        </a>
      </li>
    </ul>
    <div class="right">
      <span>{{ today }}</span>
    </div>
  
    <div class="tag_powered_by">
      <span>Powered by: <b>Enertics</b></span>
    </div>
  </div>
  <div class="Content_outer">
    <div class="row">
      <div class="col-md-12">
        <div class="tab_right">
          <!-- <app-asset-health-box></app-asset-health-box> -->
        </div>
        <div class="tab_right">
          <!-- {{ lastFileProcessedTime }} -->
          <!-- <span class="seen">
            <img
              style="width: 20px; height: 20px; cursor: pointer"
              src="./assets/settings.png"
              [matMenuTriggerFor]="menu"
          /></span> -->
        </div>
        <mat-menu #menu="matMenu" style="min-height: auto !important">
          <!-- <button mat-stroked-button color="primary" (click)="viewAsset()">
            Settings
          </button> -->
        </mat-menu>
  
        <ul
          ngbNav
          #ctdTabset="ngbNav"
          class="nav nav-tabs custom_tab"
          style="
            position: fixed;
            width: 100%;
            background-color: #f7f7f7;
            z-index: 500;
            top: 97px;
          "
        >
          <li [ngbNavItem]="'tab-1'">
            <a ngbNavLink>Monitoring</a>
            <ng-template class="ml-4 mr-4" ngbNavContent>
              <app-asset-details-box
                [company_name]="'ABCD'"
                [app_name]="'Pressure Gauge'"
                [site_name]="'Section-4D'"
                [asset_name]="'Pressure Gauge 1'"
              ></app-asset-details-box>
              <div class="inner_gauge_box col-md-12 pl-1">
                <div class="chart_boxes_outer m_b_0 vibrationChartsView">
                  <div class="ch_box acc">
                    <div class="heading">Gauge Value</div>
                    <div
                      class="inner vibrationInner"
                      style="gap: 100px"
                      *ngIf="machineVibrationLoading"
                    >
                      <div
                        class="cht"
                        *ngFor="let i of [0, 1]"
                        style="margin-top: 30px"
                      >
                        <div
                          class="skeleton skeleton-chart"
                          style="display: block"
                        ></div>
                        <div class="skeleton skeleton-chart-text"></div>
                      </div>
                    </div>
                    <div
                    *ngIf="!machineVibrationLoading"
                      class="inner vibrationInner"
                      style="justify-content: space-around"
                      
                    >
                    <div
                    class="cht"
                    *ngFor="let i of [0]"
                  >
                    <app-gauge-chart
                    [canvasWidth]="160"
                    [canvasHeight]="140"
                    [needleValue]="gauge_value"
                    [name]="'Temperature'"
                    [bottomLabel]="gauge_bottom_lable"
                    [options]="options"
                    >
                    </app-gauge-chart>
                  </div>
                      <div
                        class="cht"
                      >
                      <img src="assets/gauge.png" alt="image" style="width: 80%; height: 100% ;border-radius: 5%;" />
                      </div>
                      <!-- <div
                      class="cht"
                    >
                    <img src="assets/gauge_gauge_1_viz.jpg" alt="image" style="width: 80%; height: 100% ;border-radius: 5%;" />
                    </div> -->
                     
                    </div>
                  </div>
                  <div class="ch_box acc">
                    <div class="heading">Gauge Statistics</div>
  
                    <div
                      class="inner vibrationInner"
                      style="gap: 10px"
                      *ngIf="avgValLoading"
                    >
                      <div class="cht" *ngFor="let i of [0, 1, 2]">
                        <ng-container>
                          <div style="margin-top: 30px">
                            <div
                              class="skeleton skeleton-chart"
                              style="display: block"
                            ></div>
                            <div class="skeleton skeleton-chart-text"></div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div
                      class="inner vibrationInner"
                      style="gap: 40px"
                      *ngIf="!avgValLoading"
                    >
                      <div
                        class="cht"
                        *ngFor="let avg of avgValArray"
                      >
                        <app-gauge-chart
                        [canvasWidth]="160"
                        [canvasHeight]="140"
                        [needleValue]="avg.value"
                        [name]="avg.name"
                        [bottomLabel]="avg.bottom_label"
                        [options]="options"
                        >
                        </app-gauge-chart>
                      </div>
                 
                    </div>
                  </div>
                
  
                  <div
                    class="ch_box orien"
                    style="
                      padding-left: 0px !important;
                      padding-right: 0px !important;
                    "
                  >
                    <div class="container">
                      <div class="row">
                        <div
                          class="col-sm"
                          style="
                            padding-left: unset !important;
                            padding-right: unset !important;
                          "
                        >
                        <div class="progress_data">
                          <div class="table-responsive" style="max-height: 150px">
                            <table class="table table-hover alertSummary">
                              <thead>
                                <tr>
                                  <th>Alert Type</th>
                                  <th>Alert Details</th>
                                  <th>Alert Category</th>
                                  <th style="text-align: right">TimeStamp</th>
                                  <th style="text-align: right">Acknowledged By</th>
                                  <th style="text-align: right">Acknowledged At</th>
                                </tr>
                              </thead>
                              <tbody *ngIf="noalertmessage == ''; else elseBlock">
                                <tr *ngFor="let report of errordata">
                                  <td>
                                    <span class="circleSpan"></span>
                                  </td>
                                  <td>
                                    <span
                                      style="cursor: pointer"
                                      (click)="OnClickAlert(report)"
                                      >{{ report.error | titlecase }}
                                    </span>
                                  </td>
                                  <td>
                                    <span *ngIf="report.category != null;else elsecategory">{{report.category}}</span>
                                    <ng-template #elsecategory>
                                      <span>Asset Health</span>
                                    </ng-template>
                                  </td>
                                  <td class="text-right">
                                    <span
                                      style="cursor: pointer"
                                      (click)="
                                        taketopredominantalert(
                                          $event,
                                          report.device_raw_matric_id
                                        )
                                      "
                                      >{{ report.time }}
                                    </span>
                                  </td>
                                  <td>
                                    <span>{{
                                      report.full_name
                                        ? report.full_name
                                        : "Take Action"
                                    }}</span>
                                  </td>
                                  <td>
                                    <span *ngIf="report.ack_time; else noAckTime">
                                      {{ report.ack_time }}
                                    </span>
                                    <ng-template #noAckTime>
                                      <span>
                                        <img
                                          src="./assets/img-new/time.png"
                                          alt="time"
                                          style="width: 30px; height: 30px"
                                        />
                                      </span>
                                    </ng-template>
                                  </td>
                                </tr>
                              </tbody>
                              <tbody>
                                <ng-template #elseBlock>
                                  <tr>
                                    <td colspan="5" class="errorDisplay">
                                      {{ noalertmessage }}
                                    </td>
                                  </tr>
                                </ng-template>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="chart_boxes_outer m_b_0 vibrationChartsView">
                  <div
                    class="ch_box acc"
                    style="
                      width: 37%;
                      padding-left: 0px !important;
                      padding-right: 0px !important;
                      position: relative;
                    "
                  >
                    <div class="heading">Process Parameters</div>
                    <button
                      *ngIf="role !== 'OEM'"
                      class="setting_btn_tf cursor-pointer"
                      role="button"
                      (click)="openFlowPressModal()"
                    >
                      <img
                        src="./assets/settings.png"
                        class="cursor-pointer rotate-on-hover"
                      />
                    </button>
  
                    <div class="inner vibrationInner" style="gap: 100px">
                      <div class="cht">
                        <div *ngIf="flowLoader" style="margin-top: 30px">
                          <div
                            class="skeleton skeleton-chart"
                            style="display: block"
                          ></div>
                          <div class="skeleton skeleton-chart-text"></div>
                        </div>
                    
                        <div *ngIf="!flowLoader">
                          <app-gauge-chart
                            matTooltip=" Machine acoustics thresholds as per the ISO 29821 or customer defined specific thresholds as per their process."
                            style="color: orange"
                            [matTooltipClass]="'tooltip'"
                            [ngClass]="{
                              big_font_chartbox: flowDataObj?.hasneedle == false
                            }"
                            [canvasWidth]="160"
                            [canvasHeight]="140"
                            [needleValue]="flowDataObj?.needleValue"
                            [centralLabel]="centralLabel"
                            [options]="flowDataObj?.options"
                            [name]="'Flow '"
                            [bottomLabel]="flowDataObj?.bottomLabel"
                          >
                          </app-gauge-chart>
                        </div>
                      </div>
                      <div class="cht">
                        <div *ngIf="pressureLoader" style="margin-top: 30px">
                          <div
                            class="skeleton skeleton-chart"
                            style="display: block"
                          ></div>
                          <div class="skeleton skeleton-chart-text"></div>
                        </div>
                      
                        <div *ngIf="!pressureLoader">
                          <app-gauge-chart
                            matTooltip=" Machine acoustics thresholds as per the ISO 29821 or customer defined specific thresholds as per their process."
                            style="color: orange"
                            [matTooltipClass]="'tooltip'"
                            [ngClass]="{
                              big_font_chartbox:
                                pressureDataObj?.hasneedle == false
                            }"
                            [canvasWidth]="160"
                            [canvasHeight]="140"
                            [needleValue]="pressureDataObj?.needleValue"
                            [centralLabel]="centralLabel"
                            [options]="pressureDataObj?.options"
                            [name]="'Pressure'"
                            [bottomLabel]="pressureDataObj?.bottomLabel"
                          >
                          </app-gauge-chart>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chartBoxWrap ch_box acc">
                    <div class="heading">
                      Machine Health Status (12 hours)
                      <span
                        matTooltip="The status bar is calculated from the peak sensor value recorded in the 30 mins window.
                                  The Peak value may or may not correspond to an Unacceptable condition.
                                  Please check the 24 Hours Machine Alert Summary for actual Unacceptable condition alerts
                                   "
                        style="color: orange"
                        [matTooltipClass]="'tooltip'"
                        >*</span
                      >
                    </div>
                    <div
                      id="stackvelocitychartContainer"
                      style="height: 100px; width: 100%; display: block"
                    >
                      <div
                        *ngIf="stackvelocitychartLoader"
                        class="skeleton skeleton-health-status"
                      ></div>
                    </div>
                    <div class="heading">Asset Health Bar</div>
                  </div>
                 
                  <div class="chartBoxWrap ch_box orien">
                    <div class="settingArea">
                      <div class="heading settingBtn">
                        Machine Alert Summary (24 Hours)
                      </div>
                    </div>
                    <div class="progress_data">
                      <div class="table-responsive" style="max-height: 150px">
                        <table class="table table-hover alertSummary">
                          <thead>
                            <tr>
                              <th>Alert Type</th>
                              <th>Alert Details</th>
                              <th style="text-align: right">TimeStamp</th>
                              <th style="text-align: right">Acknowledged By</th>
                              <th style="text-align: right">Acknowledged At</th>
                            </tr>
                          </thead>
                          <tbody *ngIf="noalertmessage == ''; else elseBlock">
                            <tr *ngFor="let report of errordata">
                              <td>
                                <span class="circleSpan"></span>
                              </td>
                              <td>
                                <span
                                  style="cursor: pointer"
                                  (click)="OnClickAlert(report)"
                                  >{{ report.error | titlecase }}
                                </span>
                              </td>
                              <td class="text-right">
                                <span
                                  style="cursor: pointer"
                                  (click)="
                                    taketopredominantalert(
                                      $event,
                                      report.device_raw_matric_id
                                    )
                                  "
                                  >{{ report.time }}
                                </span>
                              </td>
                              <td>
                                <span>{{
                                  report.full_name
                                    ? report.full_name
                                    : "Take Action"
                                }}</span>
                              </td>
                              <td>
                                <span *ngIf="report.ack_time; else noAckTime">
                                  {{ report.ack_time }}
                                </span>
                                <ng-template #noAckTime>
                                  <span>
                                    <img
                                      src="./assets/img-new/time.png"
                                      alt="time"
                                      style="width: 30px; height: 30px"
                                    />
                                  </span>
                                </ng-template>
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <ng-template #elseBlock>
                              <tr>
                                <td
                                  colspan="5"
                                  class="errorDisplay"
                                  style="text-align: center"
                                >
                                  {{ noalertmessage }}
                                </td>
                              </tr>
                            </ng-template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                 
                </div> -->
                <!-- <div class="trends">
                  <app-charts></app-charts>
                </div> -->
                <div class="section">
                  <div class="sectionHeading">Trends (Actual)</div>
                  <div class="summary_boxes_outer">
                    <div class="summaryBox">
                      <ng-container *ngIf="isLoadingTempData; else trendscurrentid">
                        <app-spinner
                          class="spinner-container charts-loader"
                        ></app-spinner>
                      </ng-container>
                      <ng-template #trendscurrentid>
                        <app-line-chart
                        *ngIf="dailyTemperatureDataJson && dailyTemperatureDataJson !== '[]'"
                        [chartContainerId]="'daily-temp-line-chart'"
                        [chartData]="dailyTemperatureDataJson"              
                        [chartOptions]="tempChartOptions"
                        [chartSymbol]="tempUnit"
                        [chartBgColors]="temperatureThresholdColorsJson" 
                        [movingAvgData]="accLineMovingAvg"               
                        [movingCount]="accMovingCount"                   
                        [metricIds]="'6,7,8'"                             
                                           
                        class="windTemp"
                      ></app-line-chart>
                        @if(dailyTemperatureDataJson.length == 0){
                        <div
                          class="h5 d-flex justify-content-center align-items-center"
                        >
                          Daily Average
                        </div>
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                          *ngIf="false"
                        >
                          No Data Available
                        </div>
                        }
                      </ng-template>
                    </div>
                  
                    <!-- <div class="summaryBox">
                      <ng-container *ngIf="tempLoading; else tempid">
                        <app-spinner
                          class="spinner-container charts-loader"
                        ></app-spinner>
                      </ng-container>
                      <ng-template #tempid>
                        <app-line-chart
                          *ngIf="tempLineData && tempLineData.length > 0"
                          [chartContainerId]="'trends-temp'"
                          [chartData]="tempLineData[0]"
                          [chartOptions]="tempLineChartOptions"
                          [chartSymbol]="tempLineUnit"
                          [chartBgColors]="tempColors[0]"
                          [movingAvgData]="tempLineMovingAvg"
                          [movingCount]="tempMovingCount"
                          [metricIds]="'1,2'"
                          [asset_id]="asset_id"
                          [device_id]="device_id"
                          class="windTemp"
                        ></app-line-chart>
                        @if(tempLineData.length == 0){
                        <div
                          class="h5 d-flex justify-content-center align-items-center"
                        >
                          TEMPERATURE
                        </div>
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                          *ngIf="velLineData.length == 0"
                        >
                          No Data Available
                        </div>
                        }
                      </ng-template>
                    </div>
                    <div class="summaryBox">
                      <ng-container *ngIf="velLoading; else velid">
                        <app-spinner
                          class="spinner-container charts-loader"
                        ></app-spinner>
                      </ng-container>
                      <ng-template #velid>
                        <app-line-chart
                          *ngIf="velLineData && velLineData.length > 0"
                          [chartContainerId]="'trends-velocity'"
                          [chartData]="velLineData[0]"
                          [chartOptions]="velLineChartOptions"
                          [chartSymbol]="velLineUnit"
                          [chartBgColors]="velColors[0]"
                          [movingAvgData]="velLineMovingAvg"
                          [movingCount]="velMovingCount"
                          [metricIds]="'29,30,31'"
                          [asset_id]="asset_id"
                          [device_id]="device_id"
                          class="windTemp"
                        ></app-line-chart>
                        @if(velLineData.length == 0){
                        <div
                          class="h5 d-flex justify-content-center align-items-center"
                        >
                          VELOCITY
                        </div>
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                          *ngIf="velLineData.length == 0"
                        >
                          No Data Available
                        </div>
                        }
                      </ng-template>
                    </div>
                    <div class="summaryBox">
                      <ng-container *ngIf="audibleLoading; else audibleid">
                        <app-spinner
                          class="spinner-container charts-loader"
                        ></app-spinner>
                      </ng-container>
                      <ng-template #audibleid>
                        <app-line-chart
                          *ngIf="audibleLineData && audibleLineData.length > 0"
                          [chartContainerId]="'trends-audible'"
                          [chartData]="audibleLineData[0]"
                          [chartOptions]="audibleLineChartOptions"
                          [chartSymbol]="audibleLineUnit"
                          [chartBgColors]="audibleColors[0]"
                          [movingAvgData]="audibleLineMovingAvg"
                          [movingCount]="audibleMovingCount"
                          [metricIds]="'36'"
                          [asset_id]="asset_id"
                          [device_id]="device_id"
                          class="windTemp"
                        ></app-line-chart>
                        @if(audibleLineData.length == 0){
                        <div
                          class="h5 d-flex justify-content-center align-items-center"
                        >
                          AUDIBLE
                        </div>
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                          *ngIf="velLineData.length == 0"
                        >
                          No Data Available
                        </div>
                        }
                      </ng-template>
                    </div>
                    <div class="summaryBox">
                      <ng-container *ngIf="usoundLoading; else usoundid">
                        <app-spinner
                          class="spinner-container charts-loader"
                        ></app-spinner>
                      </ng-container>
                      <ng-template #usoundid>
                        <app-line-chart
                          *ngIf="usoundLineData && usoundLineData.length > 0"
                          [chartContainerId]="'trends-usound'"
                          [chartData]="usoundLineData[0]"
                          [chartOptions]="usoundLineChartOptions"
                          [chartSymbol]="usoundLineUnit"
                          [chartBgColors]="usoundColors[0]"
                          [movingAvgData]="usoundLineMovingAvg"
                          [movingCount]="usoundMovingCount"
                          [metricIds]="'35'"
                          [asset_id]="asset_id"
                          [device_id]="device_id"
                          class="windTemp"
                        ></app-line-chart>
                        @if(usoundLineData.length == 0){
                        <div
                          class="h5 d-flex justify-content-center align-items-center"
                        >
                          ULTRASOUND
                        </div>
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                          *ngIf="velLineData.length == 0"
                        >
                          No Data Available
                        </div>
                        }
                      </ng-template>
                    </div>
                    <div class="summaryBox">
                      <ng-container *ngIf="flowLoading; else flowid">
                        <app-spinner
                          class="spinner-container charts-loader"
                        ></app-spinner>
                      </ng-container>
                      <ng-template #flowid>
                        <app-line-chart
                          *ngIf="flowLineData && flowLineData.length > 0"
                          [chartContainerId]="'trends-flow'"
                          [chartData]="flowLineData[0]"
                          [chartOptions]="flowLineChartOptions"
                          [chartSymbol]="flowLineUnit"
                          [chartBgColors]="flowColors[0]"
                          [movingAvgData]="flowLineMovingAvg"
                          [movingCount]="flowMovingCount"
                          [metricIds]="'36'"
                          [asset_id]="asset_id"
                          [device_id]="device_id"
                          class="windTemp"
                        ></app-line-chart>
                        @if(flowLineData.length == 0){
                        <div
                          class="h5 d-flex justify-content-center align-items-center"
                        >
                          FLOW
                        </div>
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                          *ngIf="velLineData.length == 0"
                        >
                          No Data Available
                        </div>
                        }
                      </ng-template>
                    </div>
                    <div class="summaryBox">
                      <ng-container *ngIf="pressureLoading; else pressureid">
                        <app-spinner
                          class="spinner-container charts-loader"
                        ></app-spinner>
                      </ng-container>
                      <ng-template #pressureid>
                        <app-line-chart
                          *ngIf="pressureLineData && pressureLineData.length > 0"
                          [chartContainerId]="'trends-pressure'"
                          [chartData]="pressureLineData[0]"
                          [chartOptions]="pressureLineChartOptions"
                          [chartSymbol]="pressureLineUnit"
                          [chartBgColors]="pressureColors[0]"
                          [movingAvgData]="pressureLineMovingAvg"
                          [movingCount]="pressureMovingCount"
                          [metricIds]="'36'"
                          [asset_id]="asset_id"
                          [device_id]="device_id"
                          class="windTemp"
                        ></app-line-chart>
                        @if(pressureLineData.length == 0){
                        <div
                          class="h5 d-flex justify-content-center align-items-center"
                        >
                          PRESSURE
                        </div>
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                          *ngIf="velLineData.length == 0"
                        >
                          No Data Available
                        </div>
                        }
                      </ng-template>
                    </div> -->
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="ctdTabset"></div>
      </div>
    </div>
  </div>
  
  <!-- @if(showFlowPressModal){
  <app-cylinder-modal
    (closeModal)="closeModal($event)"
    [data]="flowPressModalData"
  ></app-cylinder-modal>
  } -->
  